import React from "react";

import {
  Button,
  Content,
  Grid,
  GridItem,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  Link
} from "react-router-dom";

import {
  SectionPanel
} from "shared/components/SectionPanel";

import EducationOfferBrowser
  from "./EducationOfferBrowser";


const EducationOfferPanel = ({
  isCard = false,
  showHeader = true,
  showAction = true,
  title = "Kierunki kształcenia",
  description =
    "Wybierz szkołę i kierunek dopasowany do swoich zainteresowań, pasji oraz przyszłej kariery zawodowej.",
  actionLabel = "Dowiedz się więcej",
  actionHref = "/candidate"
}) => {
  const header =
    showHeader && (title || description) ? (
      <Grid>
        <GridItem
          span={12}
          md={8}
          mdOffset={2}
        >
          <Stack hasGutter>
            {title && (
              <StackItem>
                <Content
                  component="h1"
                  style={{
                    textAlign: "center"
                  }}
                >
                  {title}
                </Content>
              </StackItem>
            )}

            {description && (
              <StackItem>
                <Content
                  component="p"
                  style={{
                    textAlign: "center"
                  }}
                >
                  {description}
                </Content>
              </StackItem>
            )}
          </Stack>
        </GridItem>
      </Grid>
    ) : null;

  const action =
    showAction && actionHref ? (
      <Button
        component={Link}
        to={actionHref}
        variant="secondary"
      >
        {actionLabel}
      </Button>
    ) : null;

  return (
    <SectionPanel
      isCard={isCard}
      header={header}
      action={action}
    >
      <EducationOfferBrowser />
    </SectionPanel>
  );
};


export default EducationOfferPanel;